/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function ReservationEdit({ login, onClose, seq, ptType, trainers }) {
  const token = localStorage.getItem("token");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState("");
  const [tname, setTname] = useState("");
  const [name, setName] = useState("");
  const [sdate, setSdate] = useState(null);
  const [hour, setHour] = useState("");
  const [hours, setHours] = useState([]);
  const [state, setState] = useState("");
  const [phone, setPhone] = useState("");
  const [point, setPoint] = useState(null);
  const [trainer, setTrainer] = useState("");
  const [editType, setEditType] = useState(ptType);

  console.log(trainers);

  // 시간
  const load_hours = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/reservation_hours",
      {
        token: token,
        cid: data.cid,
        mcd: login.mcd,
        level: login.level,
      },
    );
    if (result.data.success === 1) {
      setHours(result.data.rows);
    }
  };

  // 데이타폼
  const [data, setData] = useState({
    token: token,
    cid: login.cid,
    level: login.level,
    mcd: login.mcd,
    tcid: "",
  });

  const onHandleData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  const onSubmit = async () => {
    pr("seq=" + seq);
    pr("sdate=" + sdate);
    pr("hour=" + hour);
    pr("state=" + state);

    let result = await axios.post(
      configState.api + "/gympass_admin/reservation_edit",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
        sdate: sdate,
        hour: hour,
        state: state,
        point: point,
        trainermcd: trainer,
        pt_type: editType,
      },
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "수정되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClose();
        },
      );
    }
  };

  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/reservation_one",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
      },
    );
    if (result.data.success === 1) {
      setName(result.data.row.name);
      setSdate(result.data.row.sdate);
      setTname(result.data.row.tname);
      setHour(result.data.row.hour);
      setState(result.data.row.state);
      setPhone(result.data.row.phone);
      setPoint(result.data.row.point);
      setTrainer(
        trainers.filter((x) => x.name === result.data.row.tname)[0].id,
      );
      // setData((state) => {
      //     return { ...state, tcid: result.data.row.tcid };
      // });
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  const onDeleteClick = () => {
    Swal.fire({
      title: "삭제하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(
            configState.api + "/gympass_admin/reservation_del",
            {
              token: token,
              cid: login.cid,
              level: login.level,
              mcd: login.mcd,
              seq: seq,
            },
          );
          if (result.data.success === 1) {
            onClose();
          } else {
            Swal.fire(result.data.msg);
          }
        }
      })
      .catch((e) => alert(e));
  };

  useEffect(() => {
    load_data();
    load_hours();
  }, []);

  const onCalendarChange = (newDate) => {
    setSdate(moment(newDate).format("YYYY-MM-DD"));
  };

  return (
    <Box sx={{ width: 400 }}>
      <Box sx={{ pl: 3, pr: 3, pb: 3 }}>
        {/* 강사명 */}
        <Box display="flex" alignItems="center" style={{ marginTop: "10px" }}>
          <Typography>강사명 : {tname}</Typography>
        </Box>

        {/* 고객명 */}
        <Box display="flex" alignItems="center" style={{ marginTop: "10px" }}>
          <Typography>
            고객명 : {name} ( {phone} )
          </Typography>
        </Box>

        {/* 수업일자 */}
        <Box sx={{ mt: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
            <MobileDatePicker
              allowSameDateSelection={true}
              value={sdate}
              label="수업일자"
              renderInput={(params) => <TextField {...params} />}
              onChange={onCalendarChange}
              inputFormat={"yyyy.MM.dd"}
              autoComplete="off"
            />
          </LocalizationProvider>
        </Box>

        {/* 수업시간 */}
        {hours.length !== 0 && (
          <Box>
            <FormControl style={{ marginTop: "10px" }}>
              <InputLabel id="select-teacher-label">수업시간</InputLabel>
              <Select
                name="hour"
                labelId="select-teacher-label"
                id="select-teacher"
                style={{ width: "260px" }}
                label="가맹점"
                size="small"
                value={hour}
                onChange={(evnet) => {
                  setHour(evnet.target.value);
                }}
              >
                {hours.map((item, index) => {
                  return (
                    <MenuItem value={item.name} key={index}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>
        )}

        {login.level === "500" && (
          <>
            <Box>
              <FormControl style={{ marginTop: "10px" }}>
                <InputLabel id="select-teacher-label">트레이너</InputLabel>
                <Select
                  name="trainer"
                  labelId="select-teacher-label"
                  id="select-teacher"
                  style={{ width: "260px" }}
                  label="가맹점"
                  size="small"
                  value={trainer}
                  onChange={(evnet) => setTrainer(evnet.target.value)}
                >
                  {trainers.map((item, index) => {
                    return (
                      <MenuItem value={item.id} key={index}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
            <Box>
              <FormControl style={{ marginTop: "10px" }}>
                <InputLabel id="select-teacher-label">PT 타입</InputLabel>
                <Select
                  name="editType"
                  labelId="select-teacher-label"
                  id="select-teacher"
                  style={{ width: "260px" }}
                  label="가맹점"
                  size="small"
                  value={editType}
                  onChange={(evnet) => setEditType(evnet.target.value)}
                >
                  <MenuItem value={"PT_TRAINER"}>
                    <div
                      style={{
                        background: "rgba(124, 252, 0, 0.2)",
                        width: "100%",
                        padding: "0 0.5rem",
                      }}
                    >
                      트레이너 PT
                    </div>
                  </MenuItem>
                  <MenuItem value={"PT_MANAGER"}>
                    <div
                      style={{
                        background: "rgba(255, 160, 122, 0.2)",
                        width: "100%",
                        padding: "0 0.5rem",
                      }}
                    >
                      점장 PT
                    </div>
                  </MenuItem>
                  <MenuItem value={"GX"}>
                    <div
                      style={{
                        background: "rgba(55, 198, 255, 0.2)",
                        width: "100%",
                        padding: "0 0.5rem",
                      }}
                    >
                      그룹수업
                    </div>
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
          </>
        )}
        {/* 상태 */}
        <FormControl fullWidth style={{ marginTop: "10px" }}>
          <FormLabel>상태</FormLabel>
          <RadioGroup
            name="state"
            row
            aria-labelledby="demo-radio-buttons-group-label"
            onChange={(evnet) => {
              setState(evnet.target.value);
            }}
            value={state}
          >
            <FormControlLabel value="예약" control={<Radio />} label="예약" />
            <FormControlLabel value="결석" control={<Radio />} label="결석" />
            <FormControlLabel value="취소" control={<Radio />} label="취소" />
          </RadioGroup>
        </FormControl>

        <div style={{ fontSize: 16 }}>
          <div>출석상태</div>
          {login.level === "500" ? (
            <>
              <label htmlFor="point1a" style={{ marginRight: 6 }}>
                <input
                  name="point"
                  id="point1a"
                  type="radio"
                  style={{ marginRight: 3 }}
                  value="1"
                  checked={point === 1 ? true : false}
                  onChange={() => {
                    setPoint(1);
                  }}
                ></input>
                출석
              </label>
              <label htmlFor="point1b" style={{ marginRight: 6 }}>
                <input
                  name="point"
                  id="point1b"
                  type="radio"
                  style={{ marginRight: 3 }}
                  value="0"
                  checked={point === 0 ? true : false}
                  onChange={() => {
                    setPoint(0);
                  }}
                ></input>
                미출석
              </label>
            </>
          ) : (
            <>{point === 1 ? "출석" : "미출석"}</>
          )}
        </div>

        <Box
          style={{
            marginTop: "30px",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          {/* 관리자가 아니라면 이미 시간이 지난건 수정 불가 */}
          {login.level === "500" ||
          login.level === "100" ||
          (moment().diff(sdate, "days") < 1 && ptType !== "GX") ? (
            <Button variant="contained" onClick={onSubmit}>
              수정완료
            </Button>
          ) : null}

          <Button variant="contained" onClick={onClose}>
            닫기
          </Button>

          {login.level === "500" || login.level === "100" ? (
            <Button variant="contained" color="warning" onClick={onDeleteClick}>
              삭제
            </Button>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
}

export default ReservationEdit;
